var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"content-section content-section__centered"},[_c('prismic-rich-text',{attrs:{"field":_vm.slice.primary.text}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }